import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, DialogContentText, ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { getLoggedInUser } from '@paragon/login-tools';
import { Dialog } from '@paragon/popup-state';

import { copyCurrentSharedComponentSetToMyOrganization } from '../../store/actions/sharedComponentSetActions';
import { isLinkUser } from '../../store/selectors/isLinkUser';
import { useAppDispatch, useAppSelector } from '../hooks';

interface CopyToMyOrganizationProps {
  readonly displayType: 'button' | 'menuItem';
}

export function CopyToMyOrganization({ displayType }: CopyToMyOrganizationProps) {
  const dispatch = useAppDispatch();
  const sharedComponentSetState = useAppSelector((state) => state.sharedComponentSet);
  const sharedComponentSetIsMissingJacks = useAppSelector(
    (state) => state.sharedComponentSet.sharedComponentSetIsMissingJacks,
  );
  const openContext = useAppSelector((state) => state.application.openContext);
  const loggedInUser = useAppSelector(getLoggedInUser);
  const linkUser = useAppSelector(isLinkUser);
  const [dialogOpen, setDialogOpen] = useState(false);

  if (openContext?.type !== 'shared-component-set' || !loggedInUser || linkUser) return null;

  function onClick() {
    sharedComponentSetIsMissingJacks ? setDialogOpen(true) : dispatch(copyCurrentSharedComponentSetToMyOrganization());
  }
  const disabled =
    sharedComponentSetState.sharedComponentSet === null ||
    sharedComponentSetState.sharedComponentSetIsMissingJacks === null;
  const buttonOrMenuItem =
    displayType === 'button' ? (
      <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={onClick} disabled={disabled}>
        Copy To My Organization
      </Button>
    ) : (
      <MenuItem onClick={onClick} disabled={disabled}>
        <ListItemIcon>
          <ContentCopyIcon />
        </ListItemIcon>
        <ListItemText>Copy To My Organization</ListItemText>
      </MenuItem>
    );

  return (
    <>
      {buttonOrMenuItem}
      <Dialog
        title="Missing jack trusses"
        open={dialogOpen}
        onSubmit={() => {
          dispatch(copyCurrentSharedComponentSetToMyOrganization());
          setDialogOpen(false);
        }}
        onCancel={() => void setDialogOpen(false)}
      >
        <DialogContentText>
          This Shared Component Set is missing some jack trusses. Either ask the person who provided you with this to
          issue a new set that includes the missing jacks, or be sure to create manual loads on the girder trusses in
          the new project.
        </DialogContentText>
      </Dialog>
    </>
  );
}
